import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { buscarTimesheetAPI } from "../../services/timesheet-api";
import users from "../../data/users";

const calcularHoras = (entry, exit) => {
  if (
    !entry?.hour || !entry?.minute || !entry?.period ||
    !exit?.hour || !exit?.minute || !exit?.period
  ) return null;

  const toMinutes = ({ hour, minute, period }) => {
    let h = parseInt(hour, 10);
    const m = parseInt(minute, 10);
    if (period === "PM" && h !== 12) h += 12;
    if (period === "AM" && h === 12) h = 0;
    return h * 60 + m;
  };

  const total = toMinutes(exit) - toMinutes(entry);
  if (total <= 0) return null;

  const h = Math.floor(total / 60);
  const m = total % 60;
  return `${h}:${m.toString().padStart(2, "0")}`;
};

const TimesheetResumo = () => {
  const { year, month, userId } = useParams();
  const [jsonData, setJsonData] = useState([]);
  const [loading, setLoading] = useState(true);
  const user = users.find((u) => u.id === parseInt(userId));  
  const [valorHora] = useState(user.rate); // Pode deixar dinâmico futuramente


  useEffect(() => {
    const fetchData = async () => {
      const result = await buscarTimesheetAPI(userId, `${month}-${year}`);
      if (result.success && result.data.length > 0) {
        setJsonData(result.data[0].json_data);
      }
      setLoading(false);
    };
    fetchData();
  }, [userId, month, year]);

  const horasCalculadas = jsonData.map((entry) => {
    const worked = calcularHoras(entry.entryTime, entry.exitTime);
    return {
      date: entry.date,
      timeIn: entry.entryTime?.hour ? `${entry.entryTime.hour}:${entry.entryTime.minute} ${entry.entryTime.period}` : entry.description || "–",
      timeOut: entry.exitTime?.hour ? `${entry.exitTime.hour}:${entry.exitTime.minute} ${entry.exitTime.period}` : entry.description || "–",
      worked,
    };
  });

  const totalMinutos = horasCalculadas.reduce((acc, e) => {
    if (!e.worked) return acc;
    const [h, m] = e.worked.split(":").map(Number);
    return acc + h * 60 + m;
  }, 0);

  const totalHoras = `${Math.floor(totalMinutos / 60)}:${(totalMinutos % 60).toString().padStart(2, "0")}`;
  const totalPagar = (totalMinutos / 60) * valorHora;

  if (loading) return <div className="text-center p-8">Carregando dados...</div>;

  return (
    <div className="max-w-4xl mx-auto p-4 bg-white rounded-lg shadow-md">
      <h1 className="text-2xl font-bold text-white bg-[#C38E8F] px-4 py-2 rounded-t-md">Time Sheet</h1>

      <div className="flex justify-between px-4 py-2 border-t-4 border-[#C38E8F]">
        <div>
          <p className="text-sm">Employee Details:</p>
          <p className="font-bold">{user.name}</p>
        </div>
        <div>
          <p className="text-sm">Contact:</p>
          <p className="font-bold">{user.contact}</p>
        </div>
      </div>


      <table className="w-full border text-sm mb-6">
        <thead className="bg-[#C38E8F] text-white">
          <tr>
            <th className="border px-2 py-1 text-center">Date</th>
            <th className="border px-2 py-1 text-center">Time In</th>
            <th className="border px-2 py-1 text-center">Time Out</th>
            <th className="border px-2 py-1 text-center">Hours Worked</th>
          </tr>
        </thead>
        <tbody>
          {horasCalculadas.map((item, idx) => (
            <tr key={idx} className="border-t">
              <td className="border px-2 py-1 text-center">{item.date}</td>
              <td className="border px-2 py-1 text-gray-700 text-center">{item.timeIn}</td>
              <td className="border px-2 py-1 text-gray-700 text-center">{item.timeOut}</td>
              <td className="border px-2 py-1 text-gray-700 text-center">{item.worked || "–"}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="text-right space-y-1">
        <p className="font-semibold">TOTAL HOURS: <span className="ml-2 font-bold">{totalHoras}</span></p>
        <p className="font-semibold">HOURLY RATE: <span className="ml-2 font-bold">${valorHora.toFixed(2)}</span></p>
      </div>

      <div className="mt-4 p-4 bg-yellow-300 text-right rounded-lg">
        <p className="font-bold text-lg">TOTAL TO PAY </p>
        <p className="text-2xl font-extrabold text-red-600">${totalPagar.toFixed(2)}</p>
      </div>
    </div>
  );
};

export default TimesheetResumo;
